import { decode } from "entities";

import { type ISafeHTML, isoSafeHTML } from "../models/nominals";

export const stripHtmlToPlainText = (
    html: string | ISafeHTML | null | undefined,
): string => {
    if (!html) {
        return "";
    }
    const raw = typeof html === "string" ? html : isoSafeHTML.unwrap(html);
    return decode(raw.replace(/<[^>]+>/g, " "))
        .replace(/\s+/g, " ")
        .trim();
};

export const slugify = (value: string): string => {
    return value
        .replace(/[^\w\s-]/g, "")
        .trim()
        .toLowerCase()
        .replace(/[-\s]+/g, "-");
};
